import React, { useEffect, lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SeasonalBanner from './components/SeasonalBanner';
import VacationExperience from './components/vacation/VacationExperience';

// Code splitting : chaque page est un chunk JS séparé
const Home            = lazy(() => import('./pages/Home'));
const MentionsLegales = lazy(() => import('./pages/MentionsLegales'));
const Confidentialite = lazy(() => import('./pages/Confidentialite'));
const CGV             = lazy(() => import('./pages/CGV'));
const VillePage       = lazy(() => import('./pages/VillePage'));
const NotFound        = lazy(() => import('./pages/404'));

// ← Défini AVANT App(), pas à l'intérieur
function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

export default function App() {
  return (
    <>
      <ScrollToHash />
      <Navbar />
      <SeasonalBanner />
      <VacationExperience />
      <Suspense fallback={<div style={{ minHeight: '100vh', background: '#080808' }} />}>
        <Routes>
          <Route path="/"                 element={<Home />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite"  element={<Confidentialite />} />
          <Route path="/cgv"              element={<CGV />} />
          <Route path="/404"              element={<NotFound />} />
          <Route path="/:slug"            element={<VillePage />} />
          <Route path="*"                 element={<NotFound />} />
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
}
